import { Observable } from 'rxjs';
import { Socket } from '../socket-io/socket-io.service';
import { IdVerificationEvents } from './id-verification-events.enum';
import { IdentityVerification } from '@app/core/types/identity-verification';

export class IdVerificationSocket extends Socket {

  private inManualQueue = false;

  override onConnection() {
    super.onConnection();

    if (this.inManualQueue) {
      this.ioSocket.emit('joinManualQueue');
    }
  }

  joinClientRoom(civilId: string, brand: string): void {
    this.ioSocket.emit('joinClientRoom', { civilId, brand });
  }

  leaveClientRoom(civilId: string, brand: string): void {
    this.ioSocket.emit('leaveClientRoom', { civilId, brand });
  }

  onVerificationAdded(): Observable<IdentityVerification> {
    return this.fromEvent<IdentityVerification>(IdVerificationEvents.VERIFICATION_ADDED);
  }

  joinVerificationRoom(verificationId: number) {
    this.ioSocket.emit('joinVerificationRoom', verificationId);
  }

  leaveVerificationRoom(verificationId: number) {
    this.ioSocket.emit('leaveVerificationRoom', verificationId);
  }

  onVerificationUpdated(): Observable<IdentityVerification> {
    return this.fromEvent<IdentityVerification>(IdVerificationEvents.VERIFICATION_UPDATED);
  }

  joinManualQueue() {
    this.inManualQueue = true;
    this.ioSocket.emit('joinManualQueue');
  }

  leaveManualQueue() {
    this.inManualQueue = false;
    this.ioSocket.emit('leaveManualQueue');
  }

  onQueueInitial(): Observable<IdentityVerification[]> {
    return this.fromEvent<IdentityVerification[]>(IdVerificationEvents.QUEUE_INITIAL);
  }

  onQueueItemAdded(): Observable<IdentityVerification> {
    return this.fromEvent<IdentityVerification>(IdVerificationEvents.QUEUE_ITEM_ADDED);
  }

  onQueueItemRemoved(): Observable<{ verificationId: number }> {
    return this.fromEvent<{ verificationId: number }>(IdVerificationEvents.QUEUE_ITEM_REMOVED);
  }

  onQueueStaleItems(): Observable<IdentityVerification[]> {
    return this.fromEvent<IdentityVerification[]>(IdVerificationEvents.QUEUE_STALE_ITEMS);
  }
}